<template>
  <div>
    <div class="container" v-if="!service && loaded">
      <div>
        <p
          style="
            font-size: 16pt;
            line-height: 150%;
            margin: 15.6pt 0pt;
            orphans: 0;
            text-align: center;
            widows: 0;
          "
        >
          <span style="font-family: 黑体; font-size: 16pt; font-weight: bold"
            >服务协议</span
          >
        </p>
        <p style="margin: 0pt 0pt 12pt; text-align: justify">
          <span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >欢迎访问</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: normal;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >（下称“程序”或“软件”）</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >以使用</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >我们</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >通过</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >移动客户端</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >、小程序</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >以</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >及</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >其它方式</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >提供的产品及服务</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >（下称“服务”）</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >。我们的服务由</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >上海祥盈辰科数字科技有限公司</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >（下称“我们”</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >或“</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: normal;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >”或“</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: normal;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >平台”</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >）</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >基于</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >本协议以下条款</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >而提供</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >，</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >请仔细阅读。我们向</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >您（</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >包括入驻企业员工、</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >园区访客</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >、游客以及我们服务的其他相关方</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >，</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >统称</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >“用户”）</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >提供的服务还需要您遵守其他条款及服务准则（包括但不限于服务说明及使用帮助等</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >，</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >简称“服务规则”</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >），您应同时阅读了解予以一并接受。</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >您</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >可在“</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >首页</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >-</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >我的</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >-</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >设置</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >-</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >关于</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >我们</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >”</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >或我们</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >不时通知的软件页面</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >阅览本协议及前述相关</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >服务</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >规则</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >。若您使用</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >我们</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >的服务，即视为您承诺和遵守该等已公示的协议</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >及服务</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >规则</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >。</span
          >
        </p>
        <p style="margin: 0pt 0pt 12pt; text-align: justify">
          <span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >您同意本</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >协议</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >的方式包括但不限于：</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >1)</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >通过点击“我同意”或者其他方式接受；</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >2)</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >通过电子邮件、电话、传真、即时通信等方式所作的口头或书面表示；</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >3)</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >本服务条款及</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >服务规则</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >中有“默认同意”条款，</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >您点击同意或以其他形式实际使用了我们的服务的</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >；</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >4)</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >其他您与我们均认可的方式。</span
          >
        </p>
        <ol type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 13.25pt;
              padding-left: 15.1pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >账户</span
            >
            <ol type="1" class="awlist1" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: normal;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >为了使用我</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >们提供的服务，您</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >需要通过账号申请程序注册</span
                ><span style="font-family: 宋体; font-size: 11pt">一个</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt">账户</span
                ><span style="font-family: 宋体; font-size: 11pt">，</span
                ><span style="font-family: 宋体; font-size: 11pt">您可</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >以通过以下任一方式获得</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt">账户：</span>
                <ol
                  type="1"
                  class="awlist2"
                  style="margin: 0pt; padding-left: 0pt"
                >
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font: 7pt 'Times New Roman'"> </span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >在您启动账号申请程序向我们提交了现有的、完整的和准确的注册信息（包括但不限于</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >手机号码</span
                    ><span style="font-family: 宋体; font-size: 11pt">信息</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >）并通过验证后，我们将向您分配一个</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt">账户</span
                    ><span style="font-family: 宋体; font-size: 11pt">；</span>
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font: 7pt 'Times New Roman'"> </span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >您可使用我们许可的第三方登录方式（如微信账号授权登录等）进行登录，我们将根据第三方应用的运营方及您的共同授权，读取您在第三方账户中授权公开的信息和资料</span
                    ><span style="font-family: 宋体; font-size: 11pt">（</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >该等公开信息范围以您的授权范围为准</span
                    ><span style="font-family: 宋体; font-size: 11pt">）</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >，我们将根据您授权公开的第三方账户的信息为您注册一个与之对应的</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >账户；</span
                    >
                  </li>
                </ol>
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >在您符合账户使用规则的前提下，您将获得该账户的使用权</span
                ><span style="font-family: 宋体; font-size: 11pt">。</span
                ><span style="font-family: 宋体; font-size: 11pt">您</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >同意我们享有根据经营需要及业务规范（包括但不限于您未登录账户时间达一年以上或您存在其他违反本协议约定的行为时）回收</span
                ><span
                  style="
                    font-family: 'Times New Roman';
                    font-size: 11pt;
                    font-weight: bold;
                  "
                  >SpaceUp</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >智慧企业服务系统</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >账户的权利</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >。</span
                ><span style="font-family: 宋体; font-size: 11pt">届时，</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >您将不能再通过该</span
                ><span style="font-family: 宋体; font-size: 11pt">账户</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >登录名登录本</span
                ><span style="font-family: 宋体; font-size: 11pt">软件</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >或使用相关服务。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >如果您使用我们提供的服务，您应负责维护您的账户的保密性并限制第三方使用</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >/</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >访问您的计算机或移动设备，并确保您的登录密码未向任何第三方透露。您不得</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >在未经我们许可的前提下</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >有偿或无偿转让账户。并且，</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >您同意对在您的账户和密码下发生的所有活动承担责任。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt">在</span
                ><span style="font-family: 宋体; font-size: 11pt">账户</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >使用过程中，为了保障您的</span
                ><span style="font-family: 宋体; font-size: 11pt">账</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >号安全基于不同的终端以及您的使用习惯，我们可能采取不同的验证措施识别您的身份，验证方式包括但不限于短信验证码、服务使用信息验证</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >、邮件链接认证</span
                ><span style="font-family: 宋体; font-size: 11pt">。</span>
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >我们的服务仅限</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >14</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >岁以上的用户使用，</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >如果您未满</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >14</span
                ><span style="font-family: 宋体; font-size: 11pt">周岁，</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >请您立刻停止使用我们的服务</span
                ><span style="font-family: 宋体; font-size: 11pt">；</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >您应明确了解，若我们在服务过程中发现或怀疑您未满</span
                ><span
                  style="
                    font-family: 'Times New Roman';
                    font-size: 11pt;
                    font-weight: bold;
                  "
                  >14</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >周岁的，则我们可以随时中止或终止向您提供服务，直至您向我们提供您已满</span
                ><span
                  style="
                    font-family: 'Times New Roman';
                    font-size: 11pt;
                    font-weight: bold;
                  "
                  >14</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >周岁的证明，或协助我们获得您的监护人的明示同意。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >根据中国现行法律法规及规范性文件的规定，</span
                ><span style="font-family: 宋体; font-size: 11pt">并出于</span
                ><span style="font-family: 宋体; font-size: 11pt">履行</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >与您之间的</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >服务协议的需要</span
                ><span style="font-family: 宋体; font-size: 11pt">，</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >您有义务确保您所提供的个人信息的真实性和有效性，同时也有义务在相关信息资料发生变更时及时通知我们进行更新。</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >若因您提供任何错误、不实、过时或不完整资料，或我们有合理理由怀疑该资料为错误、不实、过时或不完整</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >，</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >或行政司法机关核实您提供的信息无效或我们发现您并非</span
                ><span
                  style="
                    font-family: 'Times New Roman';
                    font-size: 11pt;
                    font-weight: bold;
                  "
                  >SpaceUp</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >智慧企业服务系统</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >账户的初始申请注册人</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >的，我们有权暂停或终止对您提供服务，或限制您使用我们所提供服务的部分或全部功能，</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >且</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们有权（但无义务）</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >向您发出询问并要求您进行整改，若经我们通知</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >，</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >您拒不整改或不配合</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们的</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >工作的，您应自行承担因此所造成的全部损失及不利后果</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >我们有权按照相关法律法规及服务准则限制、冻结或终止您对</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >账户的使用，由此给您带来的损失（包括但不限于通信中断，用户资料及相关数据等的清空等）由您自行承担</span
                ><span style="font-family: 宋体; font-size: 11pt">。</span>
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt">您可以</span
                ><span style="font-family: 宋体; font-size: 11pt">依照</span
                ><span style="font-family: 宋体; font-size: 11pt">《</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt">隐私</span
                ><span style="font-family: 宋体; font-size: 11pt">政策</span
                ><span style="font-family: 宋体; font-size: 11pt">》</span
                ><span style="font-family: 宋体; font-size: 11pt">中</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >公布的流程和路径</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >申请注销账户。请注意，若您在注销时存在需要您履行义务的事宜在法律法规允许的范围内，您同意</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt">账户</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >所有权，以及与注册、使用</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt">账户</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >相关的服务数据和记录，包括但不限于所有注册、登录、消费记录和相关的使用统计数据，归我们所有，我们仍可根据法律法规</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >及相关规范性文件的</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >要求保存您注销前的相关信息。发生争议时，用户同意以</span
                ><span style="font-family: 宋体; font-size: 11pt">我们</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >的系统数据为准，</span
                ><span style="font-family: 宋体; font-size: 11pt">我们将</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >保证该数据的真实性。但您确认注销成功后，</span
                ><span style="font-family: 宋体; font-size: 11pt">账户</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >信息、个人身份证信息、交易记录、会员权益等将无法恢复或提供；但您仍应对您在注销</span
                ><span style="font-family: 宋体; font-size: 11pt">账</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >号前且使用平台服务期间的行为承担相应责任。</span
                >
              </li>
            </ol>
          </li>
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 13.25pt;
              padding-left: 15.1pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >服务内容</span
            >
            <ol type="1" class="awlist3" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span
                  style="
                    font-family: 'Times New Roman';
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >SpaceUp</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >智慧企业服务系统</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >向</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >您</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >提供园区内各类公共物业服务，活动及资讯信息</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >发布</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >等园区服务</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >，</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >入驻企业</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >管家</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >服务</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >，</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >以及</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >集成我们其他产品及</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >第三方智能硬件、软件或服务</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >受限</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >服务</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >：</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                >
                </span>
              </li>
            </ol>
          </li>
        </ol>
        <p style="margin: 0pt 0pt 12pt 28.35pt">
          <span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >在以下以及产品提示的其他情况下，</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >在您使用我们相关服务时将会存在功能限制或无法实现您的使用目的，</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >对此予以免责</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >：</span
          >
        </p>
        <p style="margin: 0pt 0pt 12pt 46.35pt; text-indent: -18pt">
          <span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              text-decoration: underline;
            "
            >(1)</span
          ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >若您未授权同意注册</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >，您仍可以查看我们公开的部分资讯和介绍信息，但您无法享有注册用户的其他服务。</span
          >
        </p>
        <p style="margin: 0pt 0pt 12pt 46.35pt; text-indent: -18pt">
          <span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              text-decoration: underline;
            "
            >(2)</span
          ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >若您</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >未能</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >完成注册认证企业员工</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >，</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >则</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >您</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >无法正常</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >使用</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >针对注册认证企业</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >以及员工提供的全部</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >相关服务</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >。</span
          >
        </p>
        <p style="margin: 0pt 0pt 12pt 46.35pt; text-indent: -18pt">
          <span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              text-decoration: underline;
            "
            >(3)</span
          ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >若您认证的企业未给您开通相关服务权限，</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >则您无法正常使用</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >针对注册认证企业以及认证企业授权</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >管理员</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >提供的部分相关服务。</span
          >
        </p>
        <p style="margin: 0pt 0pt 12pt 46.35pt; text-indent: -18pt">
          <span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              text-decoration: underline;
            "
            >(4)</span
          ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >享受相关服务可能需要您填写以及提供注册信息以外的</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >额外</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >信息（包括但不限于您的个人信息），若您未能准确提供该等信息，则您无法正常使用</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >该等</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >特定服务。同时您有义务确保您所提供的信息的合法性、真实性和有效性，否则，因此产生的任何争议或纠纷，或因此导致</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >造成的损失，您应自行承担全部责任。</span
          >
        </p>
        <p style="margin: 0pt 0pt 12pt 28.35pt; text-indent: -28.35pt">
          <span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              text-decoration: underline;
            "
            >2.3</span
          ><span style="font: 7pt 'Times New Roman'"
            >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
          ><span style="font-family: 宋体; font-size: 11pt">基于</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >园区运营方配置的服务功能模块</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >以及受限于上述第</span
          ><span style="font-family: 'Times New Roman'; font-size: 11pt">2</span
          ><span style="font-family: 'Times New Roman'; font-size: 11pt"
            >.2</span
          ><span style="font-family: 宋体; font-size: 11pt">条的规定</span
          ><span style="font-family: 宋体; font-size: 11pt">，</span
          ><span style="font-family: 宋体; font-size: 11pt">您</span
          ><span style="font-family: 宋体; font-size: 11pt">可</span
          ><span style="font-family: 宋体; font-size: 11pt">获得</span
          ><span style="font-family: 宋体; font-size: 11pt">包括</span
          ><span style="font-family: 宋体; font-size: 11pt">但不限于如下</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >服务的部分或全部</span
          ><span style="font-family: 宋体; font-size: 11pt">，最终服务</span
          ><span style="font-family: 宋体; font-size: 11pt">范围以</span
          ><span style="font-family: 'Times New Roman'; font-size: 11pt"
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >在各地园区选择后的具体界面呈现和要求为准</span
          ><span style="font-family: 宋体; font-size: 11pt">：</span>
        </p>
        <p style="margin: 0pt 0pt 12pt 56.7pt; text-indent: -28.35pt">
          <span style="font-family: 'Times New Roman'; font-size: 11pt"
            >2.3.1</span
          ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span
          ><span style="font-family: 宋体; font-size: 11pt">园区管理</span>
        </p>
        <p style="margin: 0pt 0pt 12pt 56.7pt">
          <span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >我们协助园区运营方以及公共物业服务提供方提供智慧园区服务，</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >您可以通过</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: normal;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >直接在线预约以及沟通园区内</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >部分</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >服务</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >，</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >了解并</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >获取园区</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >内</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >实时发布的商业信息</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: normal"
            >。</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >您知悉并了解，</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >仅为信息及技术服务平台，</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >实质物业服务由相应的公共物业服务提供方具体提供，若您与具体公共物业服务提供方发生争议的，</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >免于因具体服务争议而承担任何赔偿责任，除非相关法律法规具有相反规定。</span
          ><a name="_Hlk8194760"></a>
        </p>
        <p style="margin: 0pt 0pt 12pt 56.7pt">
          <span style="font-family: 宋体; font-size: 11pt">您可以</span
          ><span style="font-family: 宋体; font-size: 11pt">在</span
          ><span style="font-family: 'Times New Roman'; font-size: 11pt"
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt">查看</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >并参与您所在园区举办的活动。我们无法确保和控制该等活动的内容的准确性、完整性、可靠性亦无法对其承担任何责任。</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >您因参与该等活动产生的任何争议或纠纷，您应自行与活动举办方协商解决，除法定或约定义务，我们对此免于承担任何责任。</span
          >
        </p>
        <p style="margin: 0pt 0pt 12pt 56.7pt; text-indent: -28.35pt">
          <span style="font-family: 'Times New Roman'; font-size: 11pt"
            >2.3.2</span
          ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span
          ><span style="font-family: 宋体; font-size: 11pt">企业管家服务</span>
        </p>
        <p style="margin: 0pt 0pt 12pt 56.7pt; text-align: justify">
          <span style="font-family: 'Times New Roman'; font-size: 11pt"
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt">为</span
          ><span style="font-family: 宋体; font-size: 11pt">入</span
          ><span style="font-family: 宋体; font-size: 11pt">驻企业</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >提供在线账单及车位分配等部分园区入驻信息查询和在线填报服务。</span
          ><span style="font-family: 宋体; font-size: 11pt">入</span
          ><span style="font-family: 宋体; font-size: 11pt">驻企业</span
          ><span style="font-family: 宋体; font-size: 11pt">还可以通过</span
          ><span style="font-family: 'Times New Roman'; font-size: 11pt"
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >实现员工签到、审批等内部管理功能。</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >入驻企业应确保合法正当地使用我们的功能和服务，在</span
          ><span style="font-family: 'Times New Roman'; font-size: 11pt"
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >提供的信息和资料真实合法有效，</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >因此导致的任何纠纷（包括但不限与入驻企业与园区运营方、公共物业服务提供方及其内部人员的纠纷），</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >概不负责。</span
          >
        </p>
        <p style="margin: 0pt 0pt 12pt 56.7pt; text-indent: -28.35pt">
          <span style="font-family: 'Times New Roman'; font-size: 11pt"
            >2.3.3</span
          ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span
          ><span style="font-family: 宋体; font-size: 11pt"
            >祥盈辰科其他产品服务</span
          >
        </p>
        <p style="margin: 0pt 0pt 12pt 56.7pt">
          <span style="font-family: 宋体; font-size: 11pt">我们</span
          ><span style="font-family: 宋体; font-size: 11pt">可能</span
          ><span style="font-family: 宋体; font-size: 11pt">引入</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >上海祥盈辰科数字科技有限公司的其他产品（“祥盈辰科其他产品”）</span
          ><span style="font-family: 宋体; font-size: 11pt">为您提供</span
          ><span style="font-family: 宋体; font-size: 11pt">部分</span
          ><span style="font-family: 宋体; font-size: 11pt">服务</span
          ><span style="font-family: 宋体; font-size: 11pt">。</span
          ><span style="font-family: 宋体; font-size: 11pt">您在使用</span
          ><span style="font-family: 宋体; font-size: 11pt">该</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >服务时，应额外同意</span
          ><span style="font-family: 宋体; font-size: 11pt">祥盈辰科其他产品</span
          ><span style="font-family: 宋体; font-size: 11pt">的服务</span
          ><span style="font-family: 宋体; font-size: 11pt">规则</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >，并受其约束。</span
          >
        </p>
        <p style="margin: 0pt 0pt 12pt 56.7pt; text-indent: -28.35pt">
          <span style="font-family: 'Times New Roman'; font-size: 11pt"
            >2.3.4</span
          ><span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span
          ><span style="font-family: 宋体; font-size: 11pt">第三方服务</span>
        </p>
        <p style="margin: 0pt 0pt 12pt 56.7pt">
          <span style="font-family: 宋体; font-size: 11pt">我们</span
          ><span style="font-family: 宋体; font-size: 11pt">可能</span
          ><span style="font-family: 宋体; font-size: 11pt">引入</span
          ><span style="font-family: 宋体; font-size: 11pt">第三方产品</span
          ><span style="font-family: 宋体; font-size: 11pt">为您提供</span
          ><span style="font-family: 宋体; font-size: 11pt">部分</span
          ><span style="font-family: 宋体; font-size: 11pt">服务</span
          ><span style="font-family: 宋体; font-size: 11pt">，例如</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >我们将引入合法第三方支付机构</span
          ><span style="font-family: 宋体; font-size: 11pt">以及银行</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >联合为您提供支付服务</span
          ><span style="font-family: 宋体; font-size: 11pt">。</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >对于非因我们原因导致的您与第三方支付机构</span
          ><span style="font-family: 宋体; font-size: 11pt">或银行</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >之间就资金流转、手续费用支付等事项产生的任何争议或纠纷，您应自行与第三方支付机构</span
          ><span style="font-family: 宋体; font-size: 11pt">或银行</span
          ><span style="font-family: 宋体; font-size: 11pt">协商解决</span
          ><span style="font-family: 宋体; font-size: 11pt">。</span>
        </p>
        <p style="margin: 0pt 0pt 12pt 56.7pt">
          <span style="-aw-bookmark-end: _Hlk8194760"></span
          ><span style="font-family: 宋体; font-size: 11pt">我们与第三方</span
          ><span style="font-family: 宋体; font-size: 11pt">服务</span
          ><span style="font-family: 宋体; font-size: 11pt">机构</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >系独立的两方，并依据各自的法律义务和各方约定独立承担各自的法律责任。您在使用</span
          ><span style="font-family: 宋体; font-size: 11pt">第三方</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >服务时，应额外同意由第三方提供并与您签署的服务</span
          ><span style="font-family: 宋体; font-size: 11pt">规则</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >，并受其约束。</span
          >
        </p>
        <p style="margin: 0pt 0pt 12pt 56.7pt">
          <span style="font-family: 宋体; font-size: 11pt"
            >因用户使用本软件或要求</span
          ><span style="font-family: 'Times New Roman'; font-size: 11pt"
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >提供特定服务时，本软件可能会调用</span
          ><span style="font-family: 宋体; font-size: 11pt">、接入</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供，</span
          ><span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
            "
            >SpaceUp</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >智慧企业服务系统</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >不保证通过第三方提供服务及内容的安全性、准确性、有效性及其它不确定的风险</span
          ><span style="font-family: 宋体; font-size: 11pt">。</span
          ><span style="font-family: 宋体; font-size: 11pt"> </span>
        </p>
        <p style="margin: 0pt 0pt 12pt 28.35pt; text-indent: -28.35pt">
          <span
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              text-decoration: underline;
            "
            >2.4</span
          ><span style="font: 7pt 'Times New Roman'"
            >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
          ><span style="font-family: 宋体; font-size: 11pt"
            >除非您与我们另有约定，您同意本服务仅为您非商业性质的使用。</span
          ><span style="font-family: 宋体; font-size: 11pt"
            >我们所提供的服务中可能包括广告或第三方服务链接，您同意在使用过程中显示我们和第三方供应商、合作伙伴提供的广告及第三方链接。</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >除法律法规明确规定外，您应自行对依该广告信息</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >或第三方链接</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >进行的交易负责，对您因依该广告信息</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >或第三方链接</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >进行的交易或前述广告商</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >或第三方链接</span
          ><span style="font-family: 宋体; font-size: 11pt; font-weight: bold"
            >提供的内容而遭受的损失或损害，我们免于承担任何责任。</span
          >
        </p>
        <ol start="3" type="1" style="margin: 0pt; padding-left: 0pt">
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 13.25pt;
              padding-left: 15.1pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >内容和</span
            ><span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >行为规范</span
            >
            <ol type="1" class="awlist4" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >您可以在</span
                ><span
                  style="
                    font-family: 'Times New Roman';
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >SpaceUp</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >智慧企业服务系统</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >平台</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >中发布评论、意见和其他内容（包括但不限于网页、文字、标签、图片、音频、视频、图表、电子文件等），以及提出建议、意见或其他信息，唯其前提是该等内容和信息须不违反中国现行法律法规及其他规范性文件的要求，具有合法来源或得到有关权利人的授权，不含有非法、淫秽、威胁、诽谤、侵犯隐私、侵犯知识产权或以其他形式对第三方权利构成伤害、侵犯或引起公众反感，也不包含软件病毒、政治宣传、商业招揽、连锁信、大宗邮件或任何形式的</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >“垃圾邮件”。您不得使用虚假的电子邮件地址、手机号码、冒充任何他人或实体，或以其他方式对相关内容的来源进行误导。并且，</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >您主动在</span
                ><span
                  style="
                    font-family: 'Times New Roman';
                    font-size: 11pt;
                    font-weight: bold;
                  "
                  >SpaceUp</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >智慧企业服务系统</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >上</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >发表的任何形式的信息内容（包括但不限于</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >评价、咨询、各类话题文章等信息内容）</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >您同意授予我们非独有的、免费的、永久的、不可撤销的和完全的再许可权的下述许可：在全世界</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >范围内任何媒体上使用、转载、修改、改编、出版、翻译、创作衍生作品、分发和展示这些内容。</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >同时，</span
                ><span
                  style="
                    font-family: 'Times New Roman';
                    font-size: 11pt;
                    font-weight: bold;
                  "
                  >(1)</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >无论</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >您</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >是否对我们所享有的前述权利存在异议，</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >均有权将前述内容的全部或部分用于宣传推广目的，</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >您</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >同意不因</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >的前述使用行为向</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >主张任何形式的违约、侵权或其他索赔主张；</span
                ><span
                  style="
                    font-family: 'Times New Roman';
                    font-size: 11pt;
                    font-weight: bold;
                  "
                  >(2)</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >若有第三方侵犯前述内容、材料或名称的情形，则</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >您</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >在此授权</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >以相关内容权利人的身份向侵权方提起诉讼，并承诺给予</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >在现行法律法规允许下的全部必要授权以供</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >享有适格的诉讼主体身份。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: normal;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt">同时，</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >您在本服务中或通过本服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表我们的观点、立场或政策，您应对相关内容自行加以判断，并承担因信赖及使用该等内容引起的全部风险及损失，我们对此不承担任何责任。</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们保留审查、清除或编辑这些内容的权利（但非义务），除非法律另有规定，我们不对您所张贴的内容进行一一事前检查、监控、审批、核准或其他经常性的审查。</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >若您发现其他用户上传不实、违法等内容，请及时联络我们或向我们举报，并提供相关证明文件，我们将应您的合理要求提供协助并及时予以处理。您在此声明和保</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >证对于因您在我们所提供的服务平台或其他空间所提供内容引起的对我们的损害进行赔偿</span
                ><span style="font-family: 宋体; font-size: 11pt">。</span>
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >您明确知悉将您所发布的任何内容一旦上传到互联网，即有可能被其他组织或个人复制、转载、或做其它用途，请您在发布相关信息资料前审慎考虑，因此产生的风险及后果将由您自行承担。除存在法定过错外，我们不承担责任</span
                ><span style="font-family: 宋体; font-size: 11pt">。</span>
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt">您在使用</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >的过程中，不得亲自实施或协助、允许他人实施如下行为：</span
                >
                <ol
                  type="1"
                  class="awlist5"
                  style="margin: 0pt; padding-left: 0pt"
                >
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font: 7pt 'Times New Roman'"> </span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >删除本软件和</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >/</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >或其他副本</span
                    ><span
                      style="
                        font-family: 宋体;
                        font-size: 11pt;
                        font-weight: bold;
                      "
                      >中一切关于</span
                    ><span
                      style="
                        font-family: 'Times New Roman';
                        font-size: 11pt;
                        font-weight: bold;
                      "
                      >SpaceUp</span
                    ><span
                      style="
                        font-family: 宋体;
                        font-size: 11pt;
                        font-weight: bold;
                      "
                      >智慧企业服务系统</span
                    ><span
                      style="
                        font-family: 宋体;
                        font-size: 11pt;
                        font-weight: bold;
                      "
                      >版权的信息、内容</span
                    ><span style="font-family: 宋体; font-size: 11pt">；</span
                    ><span style="font-family: 宋体; font-size: 11pt"> </span>
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font: 7pt 'Times New Roman'"> </span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >以上传、下载、存储、传输等方式传播任何</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >禁止提供的内容；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font: 7pt 'Times New Roman'"> </span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >实施侵犯其他隐私权、著作权、专利权、商标权以及其他权益的行为，除非您已获得权利人充分有效的事先授权；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font: 7pt 'Times New Roman'"> </span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >实施违反法律法规、政策、规章制度以及</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >的相关协议、</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >规则的行为；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font: 7pt 'Times New Roman'"> </span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >实施干扰、破坏</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >的行为；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font: 7pt 'Times New Roman'"> </span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >侵入、使用、破坏其他用户的网络和</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >/</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >或网络设备；擅自收集其他用户的信息；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font: 7pt 'Times New Roman'"> </span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >擅自发布任何形式的广告；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font: 7pt 'Times New Roman'"> </span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >使用任何技术或手段干扰</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >的正常运转，对</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >造成不良影响；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font: 7pt 'Times New Roman'"> </span
                    ><span style="font-family: 宋体; font-size: 11pt">对</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >的服务和相关功能做出修改、篡改、屏蔽或部分屏蔽（包括</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >banner</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >广告等）；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font-family: 宋体; font-size: 11pt"
                      >采用任何技术措施盗用</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >上的内容和文字；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font-family: 宋体; font-size: 11pt"
                      >上传、发布任何内部资料、机密资料或其他无权发布的内容、信息和</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >/</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >或言论；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font-family: 宋体; font-size: 11pt"
                      >未经我们事先书面同意，擅自使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版本软件及相关信息，和</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >/</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >或建立镜像站点、擅自借助本软件发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font-family: 宋体; font-size: 11pt">对</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >进行反向工程，如反汇编、反编译等，即便当地法规允许您这么做；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font-family: 宋体; font-size: 11pt"
                      >通过修改或伪造</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >运行中的指令、数据、数据包，增加、删减、变动软件的功能或运行效果，将用于前述用途的软件通过信息网络向公众传播或者运营；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font-family: 宋体; font-size: 11pt"
                      >通过非由我们开发、授权或认可的第三方兼容软件、系统登陆或使用本软件及服务，和</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >/</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >或针对本软件和服务使用非由我们开发、授权或认证的插件和外挂；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font-family: 宋体; font-size: 11pt">利用</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >实施任何危害网络安全的行为；</span
                    >
                  </li>
                  <li
                    style="
                      font-family: 'Times New Roman';
                      font-size: 11pt;
                      list-style-position: inside;
                      margin: 0pt 0pt 12pt 28.35pt;
                      text-indent: -28.35pt;
                    "
                  >
                    <span style="font-family: 宋体; font-size: 11pt"
                      >其他以任何不合法的方式、为任何不合法的目的、或以任何与本协议不一致的方式使用</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >和我们提供的服务；或其他违反法律法规规定、侵犯其他用户合法权益、干扰</span
                    ><span
                      style="font-family: 'Times New Roman'; font-size: 11pt"
                      >SpaceUp</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >智慧企业服务系统</span
                    ><span style="font-family: 宋体; font-size: 11pt"
                      >正常运营或我们未明示授权的行为。</span
                    >
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 13.25pt;
              padding-left: 15.1pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >个人信息及隐私保护</span
            >
            <ol type="1" class="awlist6" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: normal;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >我们非常重视对您的个人信息的保护，</span
                ><span style="font-family: 宋体; font-size: 11pt">针</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >对您的个人信息，我们会遵循中国相关法律法规及规范性文件的规定，坚持按照行业标准尽最大努力予以保护和妥善保管。为保护您的个人信息，我们将</span
                ><span style="font-family: 宋体; font-size: 11pt">适用</span
                ><span style="font-family: 宋体; font-size: 11pt">《</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >隐私政策》</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >对您的个人信息进行收集、存储、使用、</span
                ><span style="font-family: 宋体; font-size: 11pt">共享</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >和保护。该</span
                ><span style="font-family: 宋体; font-size: 11pt">《</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >隐私政策》</span
                ><span style="font-family: 宋体; font-size: 11pt">是本协</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >议的有效组成部分，请您</span
                ><span style="font-family: 宋体; font-size: 11pt">详细</span
                ><span style="font-family: 宋体; font-size: 11pt">阅读。</span>
              </li>
            </ol>
          </li>
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 13.25pt;
              padding-left: 15.1pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >软件</span
            ><span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >使用许可条款</span
            >
            <ol type="1" class="awlist7" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: normal;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >除另有约定外，</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >我们在此授予您免费的、不可转让的、非独占的</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >个人许可，允</span
                ><span style="font-family: 宋体; font-size: 11pt">许您</span
                ><span style="font-family: 宋体; font-size: 11pt">在</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >中国大陆地区</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >使用由我们提供的、包含在服务中的软件。但是，您不得</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >违反本协议的</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >约定超出我们的授权范围使用本软件。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt">本软件</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >的一切知识产权，以及与</span
                ><span style="font-family: 宋体; font-size: 11pt">本软件</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图像、图表、色彩、界面设计、版面框架、有关数据、附加程序、印刷材料或电子文档等均为</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >所有，受专利法、著作权法和国际著作权条约以及其他知识产权法律法规的保护</span
                ><span style="font-family: 宋体; font-size: 11pt">。</span>
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >保留权利：</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >本协议未明示授权的其他一切权利仍归</span
                ><span style="font-family: 宋体; font-size: 11pt">我们</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >所有，用户使用其他权利时必须获得</span
                ><span style="font-family: 宋体; font-size: 11pt">我们</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >的书面同意</span
                ><span style="font-family: 宋体; font-size: 11pt">。</span>
              </li>
            </ol>
          </li>
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 13.25pt;
              padding-left: 15.1pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >版权保护</span
            >
            <ol type="1" class="awlist8" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: normal;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >我们尊重他人的知识产权。如果您认为</span
                ><span style="font-family: 宋体; font-size: 11pt">我们</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >对您的作品的使用已经构成版权侵犯，请</span
                ><span style="font-family: 宋体; font-size: 11pt">通过</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >客户服务联系方式</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >及时通知我</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >们，我们将按照现行法律法规的规定的版权侵权投诉程序予以处理。同时，您同意补偿我们因您所提交的通知而可能产生的第三方对于我们的索赔要求，包括但不限于我们因此支出的全部合理费用。</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >具体的版权侵权投诉流程请见</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >相应页面的具体展示和更新</span
                ><span style="font-family: 宋体; font-size: 11pt">。</span>
              </li>
            </ol>
          </li>
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 13.25pt;
              padding-left: 15.1pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >商标及相关权利</span
            >
            <ol type="1" class="awlist9" style="margin: 0pt; padding-left: 0pt">
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >我们的服务所包含或者提供的图表、标识、网页页眉、按钮图标、</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >应用图标、</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >文字、服务品名均为我们的商标、注册商标或商业外观</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >（统称“商标”）</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >。这些商标或商业外观不得以任何可能引起消费者混淆的方式或任何诋</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >毁或诽谤我们或我们</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >的</span
                ><span
                  style="
                    font-family: 宋体;
                    font-size: 11pt;
                    font-weight: normal;
                  "
                  >方式用于与我们无关联的任何商品或服务上。</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >未经我们的书面许可</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >，</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >程序</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >上的任何内容都不应被解释为以默许或其他方式授予许可或使用</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >程序</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >上出现的商标的权利。</span
                >
              </li>
            </ol>
          </li>
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 13.25pt;
              padding-left: 15.1pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >违约处理</span
            >
            <ol
              type="1"
              class="awlist10"
              style="margin: 0pt; padding-left: 0pt"
            >
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >如果我们发现或收到他人举报或投诉用户违反本协议约定的，我们有权不经通知随时对相关内容进行审查（包括但不限于审查用户全部信息和资料等）、删除、屏蔽，并视行为情节对违规账号处以包括但不限于警告、限制或禁止使用部分或全部功能、账号封禁直至注销的处罚，并公告处理结果。</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                >
                </span>
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >您理解并同意，我们有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此而产生的一切法律责任。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；我们因此遭受损失的，您也应当一并赔偿</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >（包括律师费用</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >及我们因此支出的全部</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >合理费用</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >）</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >。</span
                >
              </li>
            </ol>
          </li>
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 13.25pt;
              padding-left: 15.1pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >服务的修改和终止</span
            >
            <ol
              type="1"
              class="awlist11"
              style="margin: 0pt; padding-left: 0pt"
            >
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: normal;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >我们始终在不断更改和改进其所提供的服务。我们可能会增加或删除某项服务功能，也可能暂停或彻底停止某项服务。您可以随时停止使用我们的服务，我们也可能</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >在法律法规或规范性标准允许的范围内</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >随时停止向您提供服务，或随时对我们的服务增加或设置新的限制。但是，如果我们停止某项服务或增加或设置于您而言更为严格的限制时，则我们会</span
                ><span style="font-family: 宋体; font-size: 11pt">遵循</span
                ><span style="font-family: 宋体; font-size: 11pt">法</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >律法规或规范性标准的要求，</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >向您发出合理的提前通知，并让您有机会备份和转移其留存在本服务中的信息</span
                ><span style="font-family: 宋体; font-size: 11pt">。</span>
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >您理解并同意，我们有权自主决定经营策略。在我们发生合并、分立、收购、资产转让时，我们可向第三方转让本服务下相关资产；我们也可在单方通知您后，将本协议下部分或全部服务转交由第三方运营或履行。具体受让主体以我们通知的为准。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'"
                  >&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >如您违反本协议中的行为规范的，我们有权随时终止向您提供所述服务。</span
                >
              </li>
            </ol>
          </li>
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 18.75pt;
              padding-left: 9.6pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >有限责任</span
            >
            <ol
              type="1"
              class="awlist12"
              style="margin: 0pt; padding-left: 0pt"
            >
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们负责按“现状”和“可得到”的状态向您提供服务。但我们服务不作任何明示或暗示的保证，包括但不限于我们所提供服务的适用性、没有错误或疏漏、持续性、准确性、可靠性、适用于某一特定用途。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们对由于政府行为譬如政策或法规的变更、自然灾害或战争、通讯线路中断、黑客攻击、计算机病毒侵入或发作、电信部门技术调整、因政府管制而造成网站的暂时性关闭等任何影响网络正常运营的不可抗力事件，以及他人蓄意破坏、正常的系统维护、系统升级，或者因网络拥塞而导致本服务不能访问而造成的本服务所提供的信息及数据的延误、停滞或错误，以及</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >用户</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >由此受到的一切损失不承担任何责任。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >在适用法律允许的最大范围内，对因使用或不能使用本软件所产生的</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >间接性、偶然性及继发性</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >损害及风险，包括但不限于个人损害、商业赢利的丧失、贸易中断、商业信息的丢失或任何其它经济损失，</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >不承担任何责任。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >您理解并确认，我们需要定期或不定期地对我们的服务平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，我们无需为此承担任何责任，但我们应事先进行通告。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们不对您所发布或提供的信息</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >数据</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >的保存、修改、删除或储存失败负责</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >，如因我们故意或过失导致除外</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >。我们可以根据相关法律规定及服务的实际情况自行决定您在本服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。您可根据自己的需要自行备份本服务中的相关数据。您在此明确同意并接受，除非法律另有规定，如您停止使用本服务或本服务终止或您的</span
                ><span
                  style="
                    font-family: 'Times New Roman';
                    font-size: 11pt;
                    font-weight: bold;
                  "
                  >SpaceUp</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >智慧企业服务系统</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >账户被收回的，我们可以从服务器上永久地删除您的全部数据。本服务终止后，我们没有义务向您返还任何数据。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >我们对</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >本服务中</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >的非因我们故意所导致的排字错误、遗漏或疏忽等不承担责任。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >对于第三方原因造成的用户信息泄露，您应向第三方主张您的权利。</span
                >
              </li>
            </ol>
          </li>
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 18.75pt;
              padding-left: 9.6pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >适用法律</span
            >
            <ol
              type="1"
              class="awlist13"
              style="margin: 0pt; padding-left: 0pt"
            >
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: normal;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >您同意本服务条款和使用条件以及您和我们之间发生的任何争议均适用中华人民共和国法律。</span
                >
              </li>
            </ol>
          </li>
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 18.75pt;
              padding-left: 9.6pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >争议</span
            >
            <ol
              type="1"
              class="awlist14"
              style="margin: 0pt; padding-left: 0pt"
            >
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: bold;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >因本协议引起的或与本协议有关的任何争议，各方应友好协商解决；协商不成的，任何一方均可将有关争议提交至</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >深圳国际仲裁</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >院（</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >深圳仲裁委员会</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >）</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >并按照其届时有效的仲裁规则仲裁；仲裁裁决是终局的，对各方均有约束力。</span
                >
              </li>
            </ol>
          </li>
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 18.75pt;
              padding-left: 9.6pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >条款修改和可分性</span
            >
            <ol
              type="1"
              class="awlist15"
              style="margin: 0pt; padding-left: 0pt"
            >
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: normal;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >为更好地提供服务并符合相关监管政策，我们可以随时修改上述条款。请您定期查阅本条款。我们会在网页上或程序中的显著位置公布这些条款的修改通知，</span
                ><span style="font-family: 宋体; font-size: 11pt">并</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >依法向用户发出合理的提前通知，并让用户获知和同意前述变更</span
                ><span style="font-family: 宋体; font-size: 11pt">。</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >若您不同意本协议的修改内容，请您在本协议及</span
                ><span
                  style="
                    font-family: 'Times New Roman';
                    font-size: 11pt;
                    font-weight: bold;
                  "
                  >/</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >或本协议修改内容生效之日起立即停止使用</span
                ><span
                  style="
                    font-family: 'Times New Roman';
                    font-size: 11pt;
                    font-weight: bold;
                  "
                  >SpaceUp</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >智慧企业服务系统</span
                ><span
                  style="font-family: 宋体; font-size: 11pt; font-weight: bold"
                  >平台所提供的全部服务。您一旦使用或继续使用我们的服务，即视为您已了解并完全同意此协议的各项内容。</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >如果本条款中任何一条被视为废止、无效或因任何理由不可执行，该使用条件应视为可分割的且不影响任何其余条款的有效性和可执行性。</span
                >
              </li>
            </ol>
          </li>
          <li
            style="
              font-family: 'Times New Roman';
              font-size: 11pt;
              font-weight: bold;
              margin: 0pt 0pt 17pt 18.75pt;
              padding-left: 9.6pt;
              page-break-after: avoid;
              text-indent: 0pt;
            "
          >
            <span
              style="
                font-family: 宋体;
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
              "
              >其他</span
            >
            <ol
              type="1"
              class="awlist16"
              style="margin: 0pt; padding-left: 0pt"
            >
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  font-weight: normal;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >本协议各方以符合《电子签名法》要求的数据电文形式，通过</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >平台页面点击确认或以其他方式选择接受本协议，即表示各方之间已达成协议并同意接受本协议的全部约定内容以及与本协议有关的各项规则，且视为各方已认可以数据电文形式在</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >平台签署的全部约束性文件的效力，约束性文件包括但不限于</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >平台中推出的各项产品协议、规范文件、使用帮助及流程。各方均认可该签署形式系其真实意思表示，并认可该形式的协议效力对各方具有法律约束力，且承诺将不会因为其采用电子签名、数据电文的形式而否定本协议法律效力。本协议一经确认立即生效，</span
                ><span style="font-family: 'Times New Roman'; font-size: 11pt"
                  >SpaceUp</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >智慧企业服务系统</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >和用户受其约束。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >我们将通过电子邮件、短信、在本</span
                ><span style="font-family: 宋体; font-size: 11pt">软件</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >上发布通知或其它服务与您进行联系。您同意我们用这些方式提供给您的所有协议、通知、披露和其他信息是符合相关的法律法规要求的。如果我们以该等形式向您发出信息或者在本</span
                ><span style="font-family: 宋体; font-size: 11pt">软件</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >上发出相关通知，将视为您已收到所有协议、声明、披露和其它信息。</span
                >
              </li>
              <li
                style="
                  font-family: 'Times New Roman';
                  font-size: 11pt;
                  list-style-position: inside;
                  margin: 0pt 0pt 12pt;
                  text-decoration: underline;
                  text-indent: -28.35pt;
                "
              >
                <span style="font: 7pt 'Times New Roman'">&#xa0;&#xa0; </span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >我们在法律允许最大范围内对本协议拥有解释权与修改权。</span
                ><span style="font-family: 宋体; font-size: 11pt"
                  >若您对我们及本服务有任何意见，欢迎垂询客服中心。</span
                >
              </li>
            </ol>
          </li>
        </ol>
        <p style="margin: 0pt 0pt 12pt; text-align: justify">
          <span style="font-family: 宋体; font-size: 11pt">客户服务</span
          ><span style="font-family: 宋体; font-size: 11pt">联系方式</span
          ><span style="font-family: 宋体; font-size: 11pt">：</span
          ><a href="mailto:service@spaceup.com.cn"
            ><span
              style="
                color: #0000ff;
                font-family: 'Times New Roman';
                font-size: 11pt;
                text-decoration: underline;
              "
              >service@spaceup.com.cn</span
            ></a
          >
        </p>
        <p style="margin: 0pt 0pt 12pt; text-align: justify">
          <span style="font-family: 'Times New Roman'; font-size: 11pt"
            >&#xa0;</span
          >
        </p>
      </div>
      <div class="cnzz" style="display: none"></div>
    </div>
    <div class="container" v-if="service && loaded">
      <div class="viewhtml" v-html="service"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { findServiceByMarketId } from "../utils/api";
export default {
  data() {
    return {
      service: "",
      loaded: false,
    };
  },
  computed: {
    ...mapState({
      common: (state) => state.common,
    }),
  },
  created() {
    this.findServiceByMarketId();
  },
  methods: {
    findServiceByMarketId() {
      findServiceByMarketId({ marketId: this.common.marketInfo.id }).then(
        (res) => {
          this.loaded = true;
          console.log(res);
          if (res.res.code === 10000 && res.body) {
            this.service = res.body.Service || "";
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/css/common.less";
.container {
  padding: 28px;
  background: @colore;
  min-height: 100vh;
  p {
    .fontSize(15px);
    color: @color3;
    line-height: 42px;
    &.indent {
      text-indent: 2em;
    }
    &.last {
      margin: 40px 0;
    }
  }
}
.viewhtml {
  // padding: 40px 28px;
  /deep/ strong {
    font-weight: bold;
    .fontSize(15px);
    line-height: 50px;
  }
  /deep/ p {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ span {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ img {
    max-width: 100%;
    min-width: 40%;
    margin: 10px auto;
    height: auto;
    display: block;
  }
  /deep/ figcaption {
    text-align: center;
    .fontSize(14px);
    line-height: 50px;
  }
  /deep/ tr,
  td,
  th {
    .fontSize(14px);
  }
}
span {
  line-height: 1.2;
}
</style>
